/**
 * Backend `PossibleActions` values the frontend gates UI on. Keep in sync
 * with insta-agency-backend/src/permissions/allowableActions.types.ts.
 */
export const Permission = {
  /** Granted to HQ admins; implies every other permission. */
  AllowAll: 'AllowAll',
  ApproveDaySequences: 'ApproveDaySequences',
  DisputeDaySequences: 'DisputeDaySequences',
  ViewTimesheetsForApproval: 'ViewTimesheetsForApproval',
  PayrollRunPayrollReadynessReport: 'PayrollRunPayrollReadynessReport',
  PayrollRunPaycycle: 'PayrollRunPaycycle',
  PayrollForceSyncExistingPaycycle: 'PayrollForceSyncExistingPaycycle',
} as const;

export type Permission = (typeof Permission)[keyof typeof Permission];

export const hasPermission = (
  permissions: readonly string[],
  permission: Permission,
): boolean =>
  permissions.includes(Permission.AllowAll) || permissions.includes(permission);

export const hasAnyPermission = (
  permissions: readonly string[],
  required: readonly Permission[],
): boolean =>
  required.some((permission) => hasPermission(permissions, permission));
